const Form026EN = {
    stepName: {
        personalInfo: "Personal Particulars",
        scoreRecord:
            "Academic Attainment & Participation in Activities / Services",
        education: "Education",
        supportingInformation: "Supporting Information",
        fileUpload: "File Upload",
        hardCopy: "Hard Copy Submission Required",
        confirmation: "Confirmation",
    },
    label: {
        majorSubject: "Major Subject",
        specialisation: "Specialisation",
        specialisationRadio: {
            primary: "Primary",
            secondary: "Secondary",
            notSpecified: "Not Specified",
        },
        personalParticulars: "Personal Particulars",
        englishNameSurname: "Name in English (Surname)",
        englishNameOtherNames: "Name in English (Other Names)",
        surname: "surname",
        otherNames: "Other Names",
        chineseName: "Name in Chinese",
        Male: "Male",
        Female: "Female",
        flagOption: {
            1: "Yes",
            0: "No",
        },
        yearOne: "Year 1",
        yearOneTips:
            "Only applicants who will pursue <b>year one</b> study are eligible to apply for the Scholarship.",
        ifApplicable: "If applicable",
        chineseNameCommercial: "Chinese Name in Chinese Commercial Code",
        birthDay: "Date of Birth",
        birthPlace: "Place of Birth",
        sex: "Sex",
        sexOption: {
            male: "Male",
            female: "Female",
        },
        ieltsOrToeflOption: {
            IELTS: "IELTS",
            TOEFL: "TOEFL",
        },
        examTestOption: {
            exam: "Exam",
            test: "Test",
        },
        nationality: "Nationality",
        visaFlag:
            "Do you need a student visa / an entry permit for the purpose of study in HK:",
        hkid: "Hong Kong Identity Card No.",
        documentNo: "Passport / Travel Document No.",
        issuingAuthority: "Issuing Authority for Passport / Travel Document",
        issueDate: "Date of Issue",
        permanentAddress: "Permanent Address",
        correspondenceAddress: "Correspondence Address in Hong Kong",
        conTelNo: "Contact Telephone No.",
        resTelNo: "Residential Telephone No.",
        email: "Email Address",
        emailTelTips:
            "Applicants who are currently residing in Hong Kong should enter their telephone nos. in Hong Kong.  Non-local applicants who are currently residing outside Hong Kong should provide the telephone nos. in their home country / normal place of residence.  A direct contact telephone no. in Hong Kong should be provided if they have one.  Applicants should also ensure that they can be reached via email, after the application has been submitted.",
        notesTitle: "items",
        pubExamTitle:
            "Public examination results obtained (in chronological order)",
        issuedDate: "Date Issued",
        pubExam: "Public Examination",
        issuAuthority: "Issuing Authority",
        subjectsGrade: "All Subjects Passed and Grade / Level Attained",
        ieltsToeflTitle: "Results of IELTS and TOEFL",
        examinationTestTitle: "Examination / Test",
        activitiesRecordTitle:
            "Record of participation in activities / services in Senior Secondary School and / or Higher Education Institution",
        schoolYear: "School Year",
        activitiesName: "Name of Activities / Services",
        upPubExamResl: "Public examination(s) result slip(s) / certificate(s)",
        pubExamReslTitle:
            "Upload the public examination(s) result slip(s) / certificate(s) ",
        ieltsReslTitel:
            "Upload the IELTS Test Report Form(s) / TOEFL Score Report(s) (if applicable) ",
        upIteltsOrToeflRep:
            "The IELTS Test Report Form(s) / TOEFL Score Report(s)",
        secdCertTitle:
            "Upload the graduation certificate(s) / transcript(s) / testimonial(s) issued by the secondary school(s) attended",
        upSecdCert:
            "Graduation certificate(s) / transcript(s) / testimonial(s) issued by the secondary school(s)",
        transcriptsTitle:
            "Upload the transcript(s) / testimonial(s) issued by the higher education institution attended (as appropriate).",
        transcripts:
            "Transcript(s) / Testimonial(s) issued by the higher education institution attended",
        permanentAddressPlaceholder:
            "A residential address in home country or normal place of residence",
        correspondenceAddressPlaceholder:
            "If different from the address given above",
        upOfferLette:
            "Offer Letter / Supporting document to prove the admission to the higher education institution",
        offerLetteTitle:
            "Upload the offer letter / supporting document to prove the admission to the higher education institution ",
        award: "Award / Achievement / Post",
        attainResult: "Result(s) Attained",
        organisationName: "Name of Organisation",
        attendProgrammeTitle: "Study programmes attended",
        pursueProgrammeTitlePart1: "Study programme to be pursued in the ",
        pursueProgrammeTitlePart2: " school year",
        educationInstitution:
            "School(s), College(s), Higher Education Institution(s), etc. Attended",
        programmeTitle: "Title of Programme",
        highEduInstName: "Name of Higher Education Institution",
        yearOneFlag: "Year of Study:",
        attendClass: "Class Attended",
        obtainQualification: "Qualification Obtained",
        startDate: "From",
        endDate: "To",
        schoolName: "Name of School(s)",
        positionHeld: "Position Held",
        natureofWork: "Nature of Work",
        personalStatementTitle: "Personal Statement",
        expiryDate: "Date of Expiry",
        briefAccount:
            "Give a brief account of your aspirations for a career as a teacher of English",
        employmentRecord:
            "Full employment record in school(s) to date (for PGDE applicants only)",
        recommendationNotes:
            "You will need to make arrangements for the Recommendation Form to be completed and returned to the Education Bureau. The Recommendation Form should be completed by the Principal or a teacher of the secondary school you attended or by a member of the academic staff of the higher education institution you attended, who should then return the completed form to the Education Bureau on or before 24 August 2020. Otherwise, the application may not be processed and you will not be shortlisted for the selection interviews even if you have met the shortlisting criteria.",
        upHkidTitle:
            "Upload Hong Kong Identity(HKID) Card or Passport / Travel Document of the applicant",
        hkidOrPassportTravelDocument:
            "Hong Kong Identity(HKID) Card or Passport / Travel Document",
        recommendationFormTitle: "Upload duly completed Recommendation Form",
        recommendationForm: "Recommendation Form",
        declarationPart1:
            " I declare that all the information provided in this Form is accurate and true. I understand that if I willfully give any false information or withhold any material information in this Application Form, or fail to notify the office concerned of any subsequent change of information provided, it will render me liable to disqualification for selection for the Scholarship for Prospective English Teachers (",
        declarationPart2:
            "). If the Scholarship has already been awarded to me, it may be terminated and I may be required to reimburse the scholarship monies received. I understand that my application should be supported by relevant documents / evidence. If I fail to do so, my application may not be processed.",
        declarationPart3:
            " I consent to the HKSAR Government making any necessary enquiries as required in matters relating to the Scholarship and for the verification of the information given in my application. I understand that the personal data provided in the Application Form will be provided to the Student Finance Office, Working Family and Student Financial Assistance Agency for purposes relating to the award of the Scholarship for Prospective English Teachers (",
        declarationPart4: ") if my application is successful.",
        declarationFlag: "I have read and agree to these terms and conditions.",
        currDate: "Date",
        applicantName: "Name of Applicant",
        remarkFile: {
            title: "Remark:",
            content:
                "Maximum size of each file: 5MB; Acceptable file types: pdf, jpg, png; Maximum number of files: {{fileNum}}.",
        },
        statement: "Important Notes",
        notes: "Notes",
        today: "today",
        statementCheck:
            "I have read, understand and agree to the above terms and conditions",
        noteslable: {
            noteA: "(a)",
            noteB: "(b)",
            noteC: "(c)",
            noteD: "(d)",
            noteE: "(e)",
            noteF: "(f)",
            noteG: "(g)",
            noteH: "(h)",
        },
        notesList: {
            noteA: "Read the information on the EDB website (<a href='https://www.edb.gov.hk/scholarship' target='_blank' rel='noreferrer'>https://www.edb.gov.hk/scholarship</a>) and relevant Circular Memorandum (EDB CM No.{{edbcmNo}}) carefully before completing this Form.",
            noteB: "During the application, applicants are required to upload the following documents. Applicants are advised to prepare the files in electronic copies before completing this Form.  Please retain the original copies for verification at later stage.",
            noteBlist: [
                {
                    text: "Hong Kong Identity (HKID) Card or Passport / Travel Document of the applicant",
                },
                {
                    text: "Public examination(s) result slip(s) / certificate(s)",
                },
                {
                    text: "IELTS Test Report Form(s) / TOEFL Score Report(s) (if applicable)",
                },
                {
                    text: "Graduation certificate(s) / Transcript(s) / Testimonial(s) issued by the secondary school(s) attended",
                },
                {
                    text: "Transcript(s) / Testimonial(s) issued by the higher education institution attended (For PGDE applicants only)",
                },
                {
                    text: "Offer letter / Supporting document to prove the admission to the higher education institution",
                },
            ],
            noteC: "The Recommendation Form should be completed by the Principal / a teacher of the secondary school the applicant attended or a member of the academic staff of the higher education institution the applicant attended with the signature of the Principal / the teacher or the academic staff and the school chop or the chop of the department / faculty of higher education institution.  The Recommendation Form should be returned by post or in person by the Principal / the teacher of the secondary school the applicant attended or the member of the academic staff of the higher education institution the applicant attended.",
            noteD: "Complete all relevant parts in the Form accurately.",
            noteE: "Provision of all the personal data requested in this Form is obligatory (except those items clearly marked as optional). Application may not be processed if applicants fail to provide all information as required.",
            noteF: "The application period is from {{applyStart}} to {{applyEnd}}. Please submit the Application Form, together with all supporting documents, before the deadline via electronic submission. Late application will not be accepted.",
            noteG: "An on-line application number will be generated and an acknowledgement email will be sent to the applicant upon receipt of the Application Form. Please quote this number in all future correspondence.",
            noteH: "For enquiries, please send an email to ltq@edb.gov.hk or contact {{firstInquiryContact}} (Tel: {{firstInquiryContactTelNo}}) of the Professional Development and Training Division, Education Bureau.",
        },
        hardCopyCheck:
            "Arrangement will be made for the completion and submission of Recommendation Form to the Education Bureau by the deadline.",
    },
    hardCopyNotes: {
        title: "Hard Copy Submission Required (*The document should be returned by the Principal or a teacher of the secondary school the applicant attended or a member of the academic staff of the higher education institution the applicant attended)",
        item1: "Send the following document by post or in person to the Language Teacher Qualifications Team, EDB (Office Address: Room 1107, Wu Chung House, 213 Queen's Road East, Wanchai, Hong Kong).",
        item2: "Duly completed the Recommendation Form with the signature of the Principal / the teacher of the secondary school the applicant attended or a member of the academic staff of the higher education institution the applicant attended and the school chop or the chop of the department / faculty of the higher education institution.",
        item4: "Office Address:",
        item5: "Language Teacher Qualifications Team\nEducation Bureau\nRoom 1107, Wu Chung House\n213 Queen's Road East\nWanchai, Hong Kong",
        item6: "The Recommendation Form is available on the EDB website (<a href='https://www.edb.gov.hk/scholarship' target='_blank' rel='noreferrer'>https://www.edb.gov.hk/scholarship</a>)",
        item7: 'Mark "Application for the Scholarship for Prospective English Teachers" clearly on the envelope.',
    },
    errorMsg: {
        "E-0000": "Nominee Title is required [E-0000]",
        "E-0001": "Nominee Name is required [E-0001]",
        "E-0100": "Reward Nomination is required [E-0100]",
        "E-0101":
            "Contains English characters, spaces, dot, comma, hyphen and single quote. Numbers are not allowed.",
        "E-0102": "Chinese-only",
        "E-0103":
            "Must not be blank if Chinese Name in Chinese Commercial Code is not blank.",
        "E-0104": "Alphabets only",
        "E-0105": "Alpha-numeric and symbols only",
        "E-0106":
            "Contains Numeric characters and special characters which are space ( ), plus (+), hash (#), brackets (()) and hyphen (-).",
        "E-0107": "Numeric only",
        "E-0108":
            "Allow one decimal place. Contains Numeric characters and special characters which are space ( ), plus (+), hash (#), brackets (()), hyphen (-) and slash (/).",
        "E-0109": "Not match 20XX\\XX format",
        "E-0110": "Please input a valid date after the date of birth.",
        "E-0111": "Must have at least 1 file",
        "E-0112": "Must be no more than 2 files",
        "E-0113": "Not match HKID rules",
        "E-0114": "Min 8 length",
        "E-0115": "Max 20 length",
        "E-0116": "This field must be at most {{number}} characters",
        "E-0117": "This field must be at least {{number}} characters",
        "E-0118": "Not match email rules",
        "E-0119": "The value is at least 18 years after date of birth.",
    },
};
export default Form026EN;
